<template>
    <div>
        <div class="news" style="margin-top: 30px">
            <div class="main">
                <div class="swiper-container banner-swiper">
                    <div class="swiper-wrapper" v-if="bannerList.length">
                        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                            <img :src="item.image" style="width: 100%; height: 360px" />
                            <p class="swiper-title">
                                {{ item.title }}
                            </p>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
                <div class="right" style="width: 342px; flex: none">
                    <div class="block" style="margin-top: -10px">
                        <h4 class="title but_title">协会简介</h4>
                    </div>
                    <div class="list xh-organ" style="margin-top: 16px">
                        <div class="inst">
                            <img src="../../static/images/logo_03.gif" alt="" />
                            <p>
                                中国演出行业协会是由民政部批准成立的国家一级社团组织，受文化和旅游部业务主管，是由演出、网络表演经营主体以及相关领域的机构和从业人员自愿结成的全国性、行业性、非营利性社会组织。
                                <a class="more" @click="handleMoreInst">
                                    [ 更多 ]
                                </a>
                            </p>
                        </div>
                        <div class="list vip-service" style="margin-top: 22px">
                            <ul>
                                <li class="item">
                                    <a class="title" @click="toVip">申请会员</a>
                                </li>
                                <li class="item">
                                    <a class="title" @click="toVipDesc">会员服务介绍</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 行业动态 -->
        <div class="news">
            <div class="main" style="margin-top: 0">
                <div class="left">
                    <div class="block">
                        <div class="dict-list">
                            <ul style="display: flex; cursor: pointer" v-if="dynamicTypeList.length">
                                <li class="item" v-for="(itemType, index) in dynamicTypeList" :key="index" @click="handleDynamicType(itemType)" style="flex: 1; text-align: center">
                                    <span :class="[
                                            dynamicParams.dictId == itemType.id
                                                ? 'active'
                                                : '',
                                        ]" style="
                                            display: inline-block;
                                            padding: 0 10px;
                                        ">{{ itemType.dictName }}</span>
                                </li>
                            </ul>
                        </div>
                        <a class="more" @click="handleMoreDynamic">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="dynamicList.length">
                            <li v-for="(item, index) in dynamicList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.title }}</a>
                                <span class="date" v-if="item.releaseTime">
                                    {{
                                        item.releaseTime.substring(0, 10)
                                    }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="block">
                        <h4 class="title but_title">热点专题</h4>
                        <a class="more" @click="handleNoticeMore">更多>></a>
                    </div>
                    <div class="list topic">
                        <ul v-if="noticeList.length">
                            <li v-for="(item, index) in noticeList" :key="index" class="ite" @click="handleMoreTopic(item)">
                                <img class="pic" :src="item.image" alt="" />
                                <a class="tit">{{ item.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img :src="bannerPic.image" alt="" style="
                                width: 100%;
                                height: 122px;
                                margin-top: 5px;
                                cursor: pointer;
                            " @click="toDj" />
                    </div>
                </div>
            </div>
        </div>

        <!-- banner -->
        <div class="news" style="margin-top: 30px">
            <div class="main">
                <img :src="bannerCenter.image" alt="" style="width: 100%; cursor: pointer" @click="handleBan" />
            </div>
        </div>

        <!-- 行业培训 -->
        <div class="news service">
            <div class="main">
                <div class="left">
                    <div class="block">
                        <h4 class="title but_title">行业培训</h4>
                    </div>
                    <div class="service-list">
                        <ul v-if="trainList.length">
                            <li v-for="(item, index) in trainList" :key="index" class="item" @click="detailTrain(item)">
                                <img class="img" :src="item.img" alt="" width="180px" />
                                <!-- <a class="title">{{ item.name }}</a> -->
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 会议活动 -->
        <div class="news activity">
            <div class="main">
                <div class="left">
                    <div class="block">
                        <h4 class="title but_title">会议活动</h4>
                    </div>
                    <div class="activity-list">
                        <ul v-if="activityList.length">
                            <li v-for="(item, index) in activityList" :key="index" class="item" @click="detailActivety(item)">
                                <a>
                                    <img :src="item.image" alt="" />
                                    <div class="activity-cont">
                                        <div class="activity-info">
                                            <h4 class="title">
                                                {{ item.title }}
                                            </h4>
                                            <p class="preview">
                                                {{ item.description }}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 政策法规和行业研究 -->
        <div class="news">
            <div class="main">
                <div class="left">
                    <div class="block">
                        <div class="dict-list">
                            <ul style="display: flex; cursor: pointer" v-if="policyTypeList.length">
                                <li class="item" v-for="(itemType, index) in policyTypeList" :key="index" @click="handlePolicyType(itemType)" style="flex: 1; text-align: center">
                                    <span :class="[
                                            policyParams.dictId == itemType.id
                                                ? 'active'
                                                : '',
                                        ]" style="
                                            display: inline-block;
                                            padding: 0 10px;
                                        ">{{ itemType.dictName }}</span>
                                </li>
                            </ul>
                        </div>
                        <a class="more" @click="handleMorePolicy">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="policyList.length">
                            <li v-for="(item, index) in policyList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.title }}</a>
                                <span class="date" v-if="item.releaseTime">
                                    {{
                                        item.releaseTime.substring(0, 10)
                                    }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="block">
                        <div class="dict-list">
                            <ul style="display: flex; cursor: pointer" v-if="researchTypeList.length">
                                <li class="item" v-for="(
                                        itemType, index
                                    ) in researchTypeList" :key="index" @click="handleResearchType(itemType)" style="flex: 1; text-align: center">
                                    <span :class="[
                                            researchParams.dictId == itemType.id
                                                ? 'active'
                                                : '',
                                        ]" style="
                                            display: inline-block;
                                            padding: 0 10px;
                                        ">{{ itemType.dictName }}</span>
                                </li>
                            </ul>
                        </div>
                        <a class="more" @click="handleMoreResearch">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="researchList.length">
                            <li v-for="(item, index) in researchList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.title }}</a>
                                <span class="date" v-if="item.releaseTime">
                                    {{
                                        item.releaseTime.substring(0, 10)
                                    }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 演出市场动态数据展示 -->
        <div class="news" style="margin-top: 30px">
            <div class="main"></div>
        </div>
        <!-- 注册 -->
        <ModalOneReg ref="ModalOneRegDom" @loginModalShow="loginModalShow" @ModalTwoRegShow="ModalTwoRegShow"></ModalOneReg>
        <ModalTwoReg ref="ModalTwoRegDom" @handleRegister="handleRegister"></ModalTwoReg>
        <!-- 选择身份 -->
        <ModalSubject ref="ModalSubjectDom" :personalInfo="personalInfo" :entSysUserList="entSysUserList"></ModalSubject>
        <!-- 企业注册 -->
        <ModalComReg ref="ModalComRegDom"></ModalComReg>
        <!-- 飘窗 -->
        <Baywindow></Baywindow>
    </div>
</template>

<script>
import ModalOneReg from "../components/ModalOneReg";
import ModalTwoReg from "../components/ModalTwoReg.vue";
import ModalComReg from "../components/ModalComReg.vue";
import ModalSubject from "../components/ModalSubject.vue";
import { getDict, getDictPageList } from "../api/dict";
import { getNewsList } from "../api/news.js";
import { getBannerQuery } from "../api/banner";
import Baywindow from "../components/Baywindow.vue";
import {
    postRegister,
    postLogin,
    getAuthUser,
    getAuthSubject,
} from "../api/user.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        ModalOneReg,
        ModalTwoReg,
        ModalComReg,
        ModalSubject,
        Baywindow,
    },
    data() {
        return {
            // 头图
            bannerList: [],
            bannerEmpty: false,
            bannerLoading: true,

            entSysUserList: [],
            personalInfo: {
                userName: "",
                id: "",
            },
            //会员服务
            serviceList: [
                {
                    name: "入会申请",
                },
                {
                    name: "证书查询",
                },
                {
                    name: "入会申请",
                },
                {
                    name: "证书查询",
                },
                {
                    name: "入会申请",
                },
                {
                    name: "证书查询",
                },
                {
                    name: "入会申请",
                },
                {
                    name: "证书查询",
                },
                {
                    name: "入会申请",
                },
                {
                    name: "证书查询",
                },
            ],
            //行业动态类型
            dynamicTypeList: [],
            dynamicParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
                dictName: "",
            },
            //行业动态
            dynamicList: [],
            noticeParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
            },
            //热点专题
            topicList: [],
            topicParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
            },
            //热点专题
            noticeList: [],
            //行业培训
            trainList: [
                {
                    img: "../../static/img/顺序1.jpg",
                    path: "/index/Project",
                    name: "剧院剧场",
                },
                {
                    img: "../../static/img/顺序2.jpg",
                    path: "/index/Project",
                    name: "演出经纪",
                },
                {
                    img: "../../static/img/顺序3.jpg",
                    path: "/index/WM_HomePage",
                    name: "舞台舞美",
                    // path: "/index/Project",
                },
                {
                    img: "../../static/img/顺序4.jpg",
                    path: "/index/NP_HomePage",
                    // path: "/index/Project",
                    name: "网络表演",
                },
                {
                    img: "../../static/img/顺序5.jpg",
                    path: "/index/Project",
                    name: "艺术普及教育",
                },
            ],
            //标准规范
            standardTypeList: [],
            standardParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
                dictName: "",
            },
            standardList: [],
            //行业研究
            researchTypeList: [],
            researchParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
                dictName: "",
            },
            researchList: [],
            //首页会议活动
            activityTypeList: [],
            activityParams: {
                pageNo: 1,
                pageSize: 3,
                status: "1",
                dictId: "1",
                dictName: "",
            },
            activityList: [],

            //政策法规
            policyTypeList: [],
            policyParams: {
                pageNo: 1,
                pageSize: 7,
                status: "1",
                dictId: "1",
                dictName: "",
            },
            policyList: [],
            registerParams: {
                account: "",
                password: "",
            },

            //ban中部
            bannerCenter: {
                image: "",
            },

            //半通栏
            bannerPic: {
                image: "",
            },
        };
    },
    created() {
        this.getDynamicDict();
        this.getStandardDict();
        this.getPolicyDict();
        this.getResearchDict();
        this.getActivityDict();
        this.getBannerCenterDict();
        this.getBannerDict();
        this.getBannerPicDict();
    },
    methods: {
        getBannerCenterDict() {
            let params = {
                parentId: "17",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    let typeList = res.data;
                    let params = {
                        pageNo: 1,
                        pageSize: 1,
                        dictId: typeList[0].id,
                    };
                    this.getBannerCenterList(params);
                }
            });
        },

        getBannerCenterList(params) {
            getNewsList(params).then((res) => {
                if (res.code == 200) {
                    this.bannerCenter = res.data.list[0];
                }
            });
        },

        handleBan() {
            window.location.href = this.bannerCenter.url;
        },

        getBannerPicDict() {
            let params = {
                parentId: "19",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    let typeList = res.data;
                    let params = {
                        pageNo: 1,
                        pageSize: 1,
                        dictId: typeList[0].id,
                    };
                    this.getBannerPicList(params);
                }
            });
        },

        getBannerPicList(params) {
            getNewsList(params).then((res) => {
                if (res.code == 200) {
                    this.bannerPic = res.data.list[0];
                }
            });
        },

        toDj() {
            window.open(this.bannerPic.url);
        },

        loginModalShow() {
            //点击登录，判断主体身份是否
            this.$store.dispatch("setLoginStatus", true);
        },
        //企业注册
        ModalComRegShow() {
            let userType = localStorage.getItem("userType");
            if (!userType) {
                this.$store.dispatch("setLoginStatus", true);
            } else {
                if (userType == 2) {
                    this.$Message.warning("目前登录的是企业身份，不可注册企业");
                } else {
                    this.$refs.ModalComRegDom.modalStatus = true;
                }
            }
        },

        ModalOneRegShow() {
            this.$refs.ModalOneRegDom.modalStatus = true;
        },

        ModalTwoRegShow(account) {
            this.registerParams.account = account;
            this.$refs.ModalTwoRegDom.modalStatus = true;
        },

        handleRegister(password) {
            this.registerParams.password = password;
            postRegister(this.registerParams).then((res) => {
                if (res.code == 200) {
                    postLogin(this.registerParams).then((res) => {
                        if (res.code == 200) {
                            localStorage.setItem("token", res.data);
                            this.$Message.success("注册并登录成功");
                            this.$refs.ModalTwoRegDom.modalStatus = false;
                            this.getAuthSubject();
                        }
                    });
                }
            });
        },

        //获取主体信息
        getAuthSubject() {
            getAuthSubject().then((res) => {
                if (res.code == 200) {
                    //企业信息  entSysUserList;   个人信息  personalInfo;
                    let data = res.data;
                    if (data.entSysUserList.length) {
                        this.$refs.ModalSubjectDom.modalStatus = true;
                        this.entSysUserList = data.entSysUserList;
                        this.personalInfo = data.personalInfo;
                    } else {
                        this.$store.dispatch("setUserInfo", data.personalInfo);
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify(data.personalInfo)
                        );
                        localStorage.setItem("userType", "1");
                    }
                }
            });
        },

        toVip() {
            if (localStorage.getItem("userInfo")) {
                this.$router.push({
                    path: "/index/VipList",
                });
            } else {
                this.$Modal.confirm({
                    title: "提示",
                    okText: "跳转登录",
                    content: "<p>申请企业会员，需用企业账户登录</p>",
                    onOk: () => {
                        let routeUrl = this.$router.resolve({
                            path: "/index/Login",
                            query: {
                                type: "企业登录",
                            },
                        });
                        window.open(routeUrl.href, "_blank");
                    },
                    onCancel: () => {},
                });
            }
        },

        toVipDesc() {
            this.$router.push({
                path: "/index/VipList",
                query: {
                    activeName: "会员单位服务介绍",
                    step: 0,
                },
            });
        },

        handleMoreInst() {
            this.$router.push({
                path: "/index/AboutUsList",
                query: {
                    activeName: "协会简介",
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: "/index/AboutUsList",
                query: {
                    activeName: "协会简介",
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //热点专题
        getTopicDict() {
            let params = {
                parentId: "7",
                pageNo: 1,
                pageSize: 3,
            };
            getDictPageList(params).then((res) => {
                if (res.code == 200) {
                    let noticeList = res.data.list;
                    noticeList.forEach((x) => {
                        this.$set(x, "title", x.dictName);
                    });
                    this.noticeList = noticeList;
                    console.log('this.noticeList',this.noticeList)
                }
            });
        },

        handleMoreTopic(item) {
            let routeUrl = this.$router.resolve({
                path: "/index/TopicList",
                query: {
                    activeName: item.dictName,
                    id: item.id,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //行业动态
        getDynamicDict() {
            let params = {
                parentId: "2",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.dynamicTypeList = res.data;
                    let noticeTypeList = this.dynamicTypeList.splice(4, 5);
                    this.dynamicParams.dictId = this.dynamicTypeList[0].id;
                    this.dynamicParams.dictName =
                        this.dynamicTypeList[0].dictName;
                    this.noticeParams.dictId = noticeTypeList[0].id;
                    this.getNewsDynamicList();
                    this.getTopicDict();
                }
            });
        },

        handleDynamicType(item) {
            this.dynamicParams.dictId = item.id;
            this.dynamicParams.dictName = item.dictName;
            this.getNewsDynamicList();
        },

        getNewsDynamicList() {
            getNewsList(this.dynamicParams).then((res) => {
                if (res.code == 200) {
                    this.dynamicList = res.data.list;
                }
            });
        },

        handleMoreDynamic() {
            this.$router.push({
                path: "/index/DynamicList",
                query: {
                    activeName: this.dynamicParams.dictName,
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: "/index/DynamicList",
                query: {
                    activeName: this.dynamicParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        handleNoticeMore() {
            this.$router.push({
                path: "/index/DynamicList",
                query: {
                    activeName: "热点专题",
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: "/index/DynamicList",
                query: {
                    activeName: "热点专题",
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //标准规范
        getStandardDict() {
            let params = {
                parentId: "3",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.standardTypeList = res.data;
                    this.standardParams.dictId = this.standardTypeList[0].id;
                    this.standardParams.dictName =
                        this.standardTypeList[0].dictName;
                    this.getNewsStandardList();
                }
            });
        },

        handleStandardType(item) {
            this.standardParams.dictId = item.id;
            this.standardParams.dictName = item.dictName;
            this.getNewsStandardList();
        },

        getNewsStandardList() {
            getNewsList(this.standardParams).then((res) => {
                if (res.code == 200) {
                    this.standardList = res.data.list;
                }
            });
        },

        handleMoreStandard() {
            let routeUrl = this.$router.resolve({
                path: "/index/StandardList",
                query: {
                    activeName: this.standardParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },
        //首页会议活动
        getActivityDict() {
            let params = {
                parentId: "10",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.activityTypeList = res.data;
                    this.activityParams.dictId = this.activityTypeList[0].id;
                    this.activityParams.dictName =
                        this.activityTypeList[0].dictName;
                    this.getNewsActivityList();
                }
            });
        },

        getNewsActivityList() {
            getNewsList(this.activityParams).then((res) => {
                if (res.code == 200) {
                    this.activityList = res.data.list;
                }
            });
        },

        //政策法规
        getPolicyDict() {
            let params = {
                parentId: "4",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.policyTypeList = res.data;
                    this.policyParams.dictId = this.policyTypeList[0].id;
                    this.policyParams.dictName =
                        this.policyTypeList[0].dictName;
                    this.getNewsPolicyList();
                }
            });
        },

        handlePolicyType(item) {
            this.policyParams.dictId = item.id;
            this.policyParams.dictName = item.dictName;
            this.getNewsPolicyList();
        },

        getNewsPolicyList() {
            getNewsList(this.policyParams).then((res) => {
                if (res.code == 200) {
                    this.policyList = res.data.list;
                }
            });
        },

        handleMorePolicy() {
            this.$router.push({
                path: "/index/PolicyList",
                query: {
                    activeName: this.policyParams.dictName,
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: "/index/PolicyList",
                query: {
                    activeName: this.policyParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //行业研究
        getResearchDict() {
            let params = {
                parentId: "5",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.researchTypeList = res.data;
                    this.researchParams.dictId = this.researchTypeList[0].id;
                    this.researchParams.dictName =
                        this.researchTypeList[0].dictName;
                    this.getNewsResearchList();
                }
            });
        },

        handleResearchType(item) {
            this.researchParams.dictId = item.id;
            this.researchParams.dictName = item.dictName;
            this.getNewsResearchList();
        },

        getNewsResearchList() {
            getNewsList(this.researchParams).then((res) => {
                if (res.code == 200) {
                    this.researchList = res.data.list;
                }
            });
        },

        handleMoreResearch() {
            this.$router.push({
                path: "/index/ResearchList",
                query: {
                    activeName: this.researchParams.dictName,
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: "/index/ResearchList",
                query: {
                    activeName: this.researchParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        toWuMei() {
            this.$router.push({
                path: "/index/WM_HomePage",
            });
        },

        handleDetailNotice(item) {
            let routeUrl = this.$router.resolve({
                path: "/index/NoticeDetail",
                query: {
                    id: item.id,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        // 头图
        getBannerDict() {
            let params = {
                parentId: "18",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    let searchParams = {
                        pageNo: 1,
                        pageSize: 10,
                        status: "1",
                        dictId: res.data[0].id,
                    };
                    this.getBannerQuery(searchParams);
                }
            });
        },

        getBannerQuery(searchParams) {
            getNewsList(searchParams).then((res) => {
                if (res.code == 200) {
                    this.bannerList = res.data.list;
                    this.initSwiperBanner();
                }
            });
        },

        initSwiperBanner() {
            let that = this;
            setTimeout(() => {
                let mySwiper = new Swiper(".banner-swiper", {
                    autoplay: 3000,
                    speed: 1000,
                    loop: true,
                    paginationClickable: true,
                    autoplayDisableOnInteraction: false,
                    effect: "slide",
                    observer: true,
                    observerParents: true,
                    observeSlideChildren: true,
                    preventClicks: false,
                    pagination: ".banner-swiper>.swiper-pagination",
                    prevButton: ".swiper-button-prev",
                    nextButton: ".swiper-button-next",
                    onTap: function (mySwiper, event) {
                        let nodeName = event.target.nodeName;
                        if (nodeName != "IMG") {
                            return;
                        }
                        let i = mySwiper.activeIndex;
                        if (i > that.bannerList.length) {
                            i = 1;
                        }
                        let item = that.bannerList[i - 1];
                        if (item.type == 1) {
                            window.open(item.url);
                        }
                        if (item.type == 2) {
                            let routeUrl = that.$router.resolve({
                                path: "/index/NewsDetail",
                                query: {
                                    id: item.id,
                                },
                            });
                            window.open(routeUrl.href, "_blank");
                        }
                        if (item.type == 3) {
                            window.open(item.fileUrl);
                        }
                    },
                });
            }, 500);
        },

        detailNews(item) {
            switch (item.type) {
                case "1": {
                    window.open(item.url);
                    break;
                }
                case "2": {
                    let routeUrl = this.$router.resolve({
                        path: "/index/NewsDetail",
                        query: {
                            activeName: item.dictName,
                            id: item.id,
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                }
                case "3": {
                    window.open(item.fileUrl);
                    break;
                }
            }
        },

        detailNewsTopic(item) {
            let routeUrl = this.$router.resolve({
                path: "/index/TopicList",
                query: {
                    activeName: item.title,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        detailActivety(item) {
            switch (item.type) {
                case "1": {
                    window.open(item.url);
                    break;
                }
                case "2": {
                    let routeUrl = this.$router.resolve({
                        path: "/index/NewsDetail",
                        query: {
                            activeName: item.dictName,
                            id: item.id,
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                }
                case "3": {
                    window.open(item.fileUrl);
                    break;
                }
            }
        },

        detailTrain(item) {
            if (!item.path) {
                return;
            }
            this.$router.push({
                path: item.path,
                query: {
                    name: item.name,
                },
            });
            return;
            let routeUrl = this.$router.resolve({
                path: item.path,
            });
            window.open(routeUrl.href, "_blank");
        },
    },
};
</script>

<style>
@import "../assets/style.css";
@import "../assets/style-mob.css";
</style>

<style scoped>
.swiper2 {
    width: 12rem;
    padding-top: 0.4rem;
    padding-bottom: 0.2rem;
    overflow: hidden;
    margin: 0 auto;
}

.partner-img {
    width: 3.1rem;
    height: 0.58rem;
    display: block;
    margin: 0 auto;
}

.active {
    color: #2763ce;
    border-bottom: 2px solid #2763ce;
    font-weight: bold;
}
</style>


<style>
.swiper-pagination-bullet-active {
    background: #306baf !important;
    opacity: 1 !important;
}

.swiper-button-prev {
    width: 20px !important;
    height: 32px !important;
    background: url(../../static/images/slider-arrow.png) !important;
}

.swiper-button-next {
    width: 20px !important;
    height: 32px !important;
    background: url(../../static/images/slider-arrow.png) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue